import React from 'react';
import './Select.css'
const Select = ({ 
  label, 
  value, 
  onChange, 
  options = [],
  size = 'md', // sm, md, lg
  id, 
  className = '', 
  placeholder = '', 
  selectStyle = {},
  labelStyle = {} 
}) => {
  
  const selectId = id || `select-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "select-sm";
      case "lg":
        return "select-lg";
      default:
        return "select-md";
    }
  };

  return (
    <div className={`select-container ${className}`}>
      {label && <label htmlFor={selectId} style={{ ...labelStyle }}>{label}</label>}
      <select
        id={selectId}
        value={value}
        onChange={onChange}
        className={`select-input ${getSizeClass()}`}
        style={{ ...selectStyle }}
      >
        {placeholder && <option value="" disabled>{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value ?? opt} value={opt.value ?? opt}>
            {opt.label ?? opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
